// extracted by mini-css-extract-plugin
export default {"loginFormBtn":"LoginButton_loginFormBtn__FrATG"};